import {
  GET_ALL_PAGES_PENDING,
  GET_ALL_PAGES_FULFILLED,
  GET_ALL_PAGES_REJECTED
} from "../actions/page";

const initialState = {
  fetching: false,
  page: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_PAGES_PENDING:
      return {
        ...state,
        fetching: true
      };
    case GET_ALL_PAGES_FULFILLED:
      return {
        ...state,
        page: action.payload,
        fetching: false
      };
    case GET_ALL_PAGES_REJECTED:
      return {
        ...state,
        fetching: false
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/pageReducer.js